import { USER_REQUEST, USER_ERROR, USER_SUCCESS } from '../actions/user'
import Vue from 'vue'
import '../../plugins/axios'
import { AUTH_LOGOUT } from '../actions/auth'
import store from '../../store'
import axios from 'axios'

Vue.use(axios)

const state = { status: '', profile: {} }

const getters = {
  getProfile: state => state.profile,
  isProfileLoaded: state => !!state.profile.username
}

const actions = {
  [USER_REQUEST]: ({ commit, dispatch }) => {
    commit(USER_REQUEST)
    const config = {
      method: 'get',
      url: 'https://residencial-services.intrare.app/users/me/',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Token ' + store.getters.getToken
      }
    }
    axios(config).then(resp => {
      if (localStorage.getItem('enable_2fa')) {
        console.log('OTPPPP')
      } else {
        console.log('NOOOOO OTP')
        if (resp.data.enable_2fa) {
          const config = {
            method: 'post',
            url: 'https://residencial-services.intrare.app/users/otp',
            headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
            }
          }
          axios(config).then(resp => {
            console.log('OTP Enviado')
          }).catch(resp => {
            console.log('OTP Error')
          })
        }
      }
      commit(USER_SUCCESS, resp.data)
    }).catch(resp => {
      commit(USER_ERROR)
      dispatch(AUTH_LOGOUT)
    })
  }
}

const mutations = {
  [USER_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [USER_SUCCESS]: (state, resp) => {
    state.status = 'success'
    Vue.set(state, 'profile', resp)
  },
  [USER_ERROR]: (state) => {
    state.status = 'error'
  },
  [AUTH_LOGOUT]: (state) => {
    state.profile = {}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
